import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const PHONE = "918086568787"; // +91 80865 68787
const MSG = "Hi Konattu Group, I have a question about your products.";

export default function WhatsAppButton() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MSG)}`;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Konattu Group on WhatsApp"
      data-testid="whatsapp-float"
      initial={{ opacity: 0, scale: 0.6, y: 24 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-[60] group inline-flex items-center gap-0 md:gap-3 bg-[#25D366] text-white pl-[14px] pr-[14px] md:pr-5 py-[14px] rounded-full shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] hover:shadow-[0_18px_40px_-8px_rgba(37,211,102,0.75)] transition-shadow"
    >
      <span className="relative flex h-3 w-3 -ml-1 -mt-6 hidden md:block">
        <span className="animate-ping absolute inline-flex h-3 w-3 rounded-full bg-white opacity-70" />
        <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
      </span>
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true" className="shrink-0">
        <path d="M19.11 17.31c-.29-.14-1.7-.84-1.96-.93-.26-.1-.45-.14-.64.14-.19.29-.74.93-.9 1.12-.17.19-.33.21-.62.07-.29-.14-1.22-.45-2.32-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.59.13-.13.29-.33.43-.5.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.64-1.55-.88-2.13-.23-.55-.47-.48-.64-.48h-.55c-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.38 0 1.4 1.02 2.76 1.16 2.95.14.19 2 3.05 4.85 4.28.68.29 1.21.46 1.62.59.68.22 1.3.19 1.79.12.55-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.33zM16.02 5C9.94 5 5 9.94 5 16c0 1.94.5 3.83 1.46 5.5L5 27l5.65-1.48A10.94 10.94 0 0 0 16 27c6.06 0 11-4.94 11-11S22.06 5 16.02 5zm0 20.09a9.06 9.06 0 0 1-4.62-1.27l-.33-.2-3.35.88.89-3.27-.21-.34a9.03 9.03 0 0 1-1.4-4.85c0-5 4.07-9.07 9.07-9.07S25.09 11.04 25.09 16c0 5-4.07 9.09-9.07 9.09z" />
      </svg>
      <span className="font-body text-sm font-medium hidden md:inline">Chat with us</span>
    </motion.a>
  );
}
